import { LazyLoadImage } from 'react-lazy-load-image-component';
import {
  PlusCircleIcon,
  TrashIcon,
  CheckCircleIcon,
  EnvelopeIcon,
} from '@heroicons/react/24/outline';
import StatusOptions from "../constants/status";

export const JobSearchTable = ({ jobData, searching }) => {

  return (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
      {searching && (
        <div
          role="status"
          className="absolute -translate-x-1/2 -translate-y-1/2 mt-4 left-1/2"
        >
          <svg
            aria-hidden="true"
            className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
      )}
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" className="p-4">
              <div className="flex items-center"></div>
            </th>
            <th scope="col" className="px-6 py-3">
              Job Title
            </th>
            <th scope="col" className="px-6 py-3">
              Status
            </th>
            <th scope="col" className="px-6 py-3">
              Location
            </th>
          </tr>
        </thead>
        <tbody>
          {jobData &&
            jobData.map((job) => {
              return (
                <tr
                  key={job.id}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  <td className="w-4 p-4 w-20 h-20">
                    { !job.confidential ? <div className="flex items-center">
                      <LazyLoadImage
                        className="w-20 h-20"
                        src={`https://filmconnx-production.s3.amazonaws.com/uploads/${job.image}`}
                      />
                    </div> : <></>
                    }
                    { !!job.confidential ? <div className="flex items-center w-20 h-20">
                      <LazyLoadImage
                        className="w-20 h-20"
                        src={`https://res.cloudinary.com/prodz-com/image/upload/v1687275142/confidential-8cd0841b741733d249b2e71a904cde904a0e67a95fef2f125b38453ec12fc0b7_ars9ed.png`}
                      />
                    </div> : <></>
                    }
                  </td>
                  <th
                    scope="row"
                    className="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap dark:text-white"
                  >
                    <div className="pl-3">
                      <div className="text-base font-semibold">
                        <a
                          target="_blank"
                          className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                          href={`/admin/job/${job.slug}`}
                        >
                          {job.title}
                        </a>
                      </div>
                    </div>
                  </th>
                  <td className="px-6 py-4">
                   { StatusOptions.find(({ value }) => value === parseInt(job.status))?.label || ''} ({job.closed ? 'Closed' : 'Open'})
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center">
                      {job.region || job.city}
                    </div>
                  </td>
                  
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};
